
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/student/landing/blog",
      function () {
        return require("private-next-pages/[lang]/student/landing/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/student/landing/blog"])
      });
    }
  